import { FC, useMemo } from "react";
import { Stack } from "@mui/material";
import { Point } from "highcharts";
import { CommitmentsHighChart } from "@/components/pages/commtiments/common/components/chart/CommitmentsHighChart";
import { generateUtilizationAndCoverageMultiTypeChartTooltip } from "@/components/pages/commtiments/utilization-and-coverage/components/content/chart/multi-type-chart/utils/generateUtilizationAndCoverageMultiTypeChartTooltip";
import { useAppSelector } from "@/store/hooks";
import { azureReservationsForGranularLoadingSelector } from "@/store/commitments/selectors/azure/reservations/data/loading/azureReservationsForGranularLoadingSelector";
import { commitmentsDateGranularitySelector } from "@/store/commitments/selectors/common/view-options/commitmentsDateGranularitySelector";
import { azureReservationsGranularDataGroupedByDateSelector } from "@/store/commitments/selectors/azure/reservations/data/granular/azureReservationsGranularDataGroupedByDateSelector";
import { formatDateByFrequencyType } from "@/utils/helpers/date-time/datetime-format";
import { CommitmentsDateGranularity } from "@/components/pages/commtiments/common/components/options/date-granularity/CommitmentsDateGranularity";

export const AzureReservationsMultiTypeChart: FC = () => {
  const loading = useAppSelector(azureReservationsForGranularLoadingSelector);
  const dataPoint = useAppSelector(commitmentsDateGranularitySelector);
  const dataGroupedByDate = useAppSelector(
    azureReservationsGranularDataGroupedByDateSelector,
  );

  const highChartProps = useMemo(() => {
    const labelFormatter = (value: string) =>
      formatDateByFrequencyType(dataPoint, value);
    return {
      loading,
      dataGroupedByDate,
      labelFormatter,
      maxHeight: 160,
      tooltipMarkupGenerator: (point: Point) =>
        generateUtilizationAndCoverageMultiTypeChartTooltip({
          point,
          dataGroupedByDate,
          labelFormatter,
        }),
      chartSx: {
        mt: 1,
      },
    };
  }, [dataPoint, dataGroupedByDate, loading]);

  return (
    <Stack
      border={1}
      borderRadius={2}
      borderColor="grey.300"
      height="100%"
      py={1}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="end"
        spacing={1}
        px={1}
      >
        <CommitmentsDateGranularity />
      </Stack>

      <CommitmentsHighChart {...highChartProps} />
    </Stack>
  );
};
